var map = {
	"./icon-3d-model.svg": "./src/assets/icons/icon-3d-model.svg",
	"./icon-account.svg": "./src/assets/icons/icon-account.svg",
	"./icon-arrow--cta-long.svg": "./src/assets/icons/icon-arrow--cta-long.svg",
	"./icon-arrow--cta.svg": "./src/assets/icons/icon-arrow--cta.svg",
	"./icon-arrow--down.svg": "./src/assets/icons/icon-arrow--down.svg",
	"./icon-arrow--dropdown.svg": "./src/assets/icons/icon-arrow--dropdown.svg",
	"./icon-arrow--holiday.svg": "./src/assets/icons/icon-arrow--holiday.svg",
	"./icon-arrow--left.svg": "./src/assets/icons/icon-arrow--left.svg",
	"./icon-arrow--right.svg": "./src/assets/icons/icon-arrow--right.svg",
	"./icon-arrow--small.svg": "./src/assets/icons/icon-arrow--small.svg",
	"./icon-arrow--thick-left.svg": "./src/assets/icons/icon-arrow--thick-left.svg",
	"./icon-arrow--thick-right.svg": "./src/assets/icons/icon-arrow--thick-right.svg",
	"./icon-arrow--up.svg": "./src/assets/icons/icon-arrow--up.svg",
	"./icon-cart.svg": "./src/assets/icons/icon-cart.svg",
	"./icon-chat.svg": "./src/assets/icons/icon-chat.svg",
	"./icon-check--circle.svg": "./src/assets/icons/icon-check--circle.svg",
	"./icon-check--sharp.svg": "./src/assets/icons/icon-check--sharp.svg",
	"./icon-check.svg": "./src/assets/icons/icon-check.svg",
	"./icon-chevron--down-light.svg": "./src/assets/icons/icon-chevron--down-light.svg",
	"./icon-chevron--down.svg": "./src/assets/icons/icon-chevron--down.svg",
	"./icon-chevron--left.svg": "./src/assets/icons/icon-chevron--left.svg",
	"./icon-chevron--right--custom-color.svg": "./src/assets/icons/icon-chevron--right--custom-color.svg",
	"./icon-chevron--right.svg": "./src/assets/icons/icon-chevron--right.svg",
	"./icon-chevron--thick-left.svg": "./src/assets/icons/icon-chevron--thick-left.svg",
	"./icon-chevron--thick-right.svg": "./src/assets/icons/icon-chevron--thick-right.svg",
	"./icon-chevron--thick-sharp-right.svg": "./src/assets/icons/icon-chevron--thick-sharp-right.svg",
	"./icon-circle-checkmark.svg": "./src/assets/icons/icon-circle-checkmark.svg",
	"./icon-close--cart-confirmation.svg": "./src/assets/icons/icon-close--cart-confirmation.svg",
	"./icon-close.svg": "./src/assets/icons/icon-close.svg",
	"./icon-clothes.svg": "./src/assets/icons/icon-clothes.svg",
	"./icon-duer-logo.svg": "./src/assets/icons/icon-duer-logo.svg",
	"./icon-lock.svg": "./src/assets/icons/icon-lock.svg",
	"./icon-minus.svg": "./src/assets/icons/icon-minus.svg",
	"./icon-out-of-stock.svg": "./src/assets/icons/icon-out-of-stock.svg",
	"./icon-pause--banner.svg": "./src/assets/icons/icon-pause--banner.svg",
	"./icon-pause--white.svg": "./src/assets/icons/icon-pause--white.svg",
	"./icon-pause.svg": "./src/assets/icons/icon-pause.svg",
	"./icon-phone.svg": "./src/assets/icons/icon-phone.svg",
	"./icon-play--banner.svg": "./src/assets/icons/icon-play--banner.svg",
	"./icon-play--custom.svg": "./src/assets/icons/icon-play--custom.svg",
	"./icon-play--dark.svg": "./src/assets/icons/icon-play--dark.svg",
	"./icon-play--orange.svg": "./src/assets/icons/icon-play--orange.svg",
	"./icon-play--white.svg": "./src/assets/icons/icon-play--white.svg",
	"./icon-play.svg": "./src/assets/icons/icon-play.svg",
	"./icon-plus.svg": "./src/assets/icons/icon-plus.svg",
	"./icon-remove.svg": "./src/assets/icons/icon-remove.svg",
	"./icon-return-arrows.svg": "./src/assets/icons/icon-return-arrows.svg",
	"./icon-return.svg": "./src/assets/icons/icon-return.svg",
	"./icon-reviews--5-stars.svg": "./src/assets/icons/icon-reviews--5-stars.svg",
	"./icon-search.svg": "./src/assets/icons/icon-search.svg",
	"./icon-shipping.svg": "./src/assets/icons/icon-shipping.svg",
	"./icon-star.svg": "./src/assets/icons/icon-star.svg",
	"./icon-stretch-line.svg": "./src/assets/icons/icon-stretch-line.svg",
	"./icon-tooltip.svg": "./src/assets/icons/icon-tooltip.svg",
	"./icon-trail-marker.svg": "./src/assets/icons/icon-trail-marker.svg",
	"./icon-triangle--down.svg": "./src/assets/icons/icon-triangle--down.svg",
	"./icon-truck.svg": "./src/assets/icons/icon-truck.svg",
	"./icon-zoom.svg": "./src/assets/icons/icon-zoom.svg",
	"./social-icons/icon-facebook.svg": "./src/assets/icons/social-icons/icon-facebook.svg",
	"./social-icons/icon-instagram.svg": "./src/assets/icons/social-icons/icon-instagram.svg",
	"./social-icons/icon-linkedin.svg": "./src/assets/icons/social-icons/icon-linkedin.svg",
	"./social-icons/icon-pinterest.svg": "./src/assets/icons/social-icons/icon-pinterest.svg",
	"./social-icons/icon-rss.svg": "./src/assets/icons/social-icons/icon-rss.svg",
	"./social-icons/icon-shopify-logo.svg": "./src/assets/icons/social-icons/icon-shopify-logo.svg",
	"./social-icons/icon-snapchat.svg": "./src/assets/icons/social-icons/icon-snapchat.svg",
	"./social-icons/icon-tumblr.svg": "./src/assets/icons/social-icons/icon-tumblr.svg",
	"./social-icons/icon-twitter.svg": "./src/assets/icons/social-icons/icon-twitter.svg",
	"./social-icons/icon-vimeo.svg": "./src/assets/icons/social-icons/icon-vimeo.svg",
	"./social-icons/icon-youtube.svg": "./src/assets/icons/social-icons/icon-youtube.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive \\.svg$";